<div>
  <p *ngIf="calendarBenefits && calendarBenefits.length > 0" class="font-sans text-h600 text-eggplant-100/[0.25] mb-48">{{'PAYMENT_CALENDAR.NEXT_12' | translate}}</p>
  <!-- <div *ngIf="calendarBenefits && calendarBenefits.length > 0" class="flex gap-x-6 items-center justify-center w-fit p-12 my-16 mx-auto">
    <fun-new-button size="m" (eventClick)="changeMode('list')" icon="coin-stack" iconPosition="right" [buttonType]="mode === 'list' ? 'primaryDark' : 'secondaryDark'" title="{{ 'CALENDAR.LIST' | translate }}"></fun-new-button>
    <fun-new-button size="m" (eventClick)="changeMode('calendar')" icon="calendar" iconPosition="right" [buttonType]="mode === 'calendar' ? 'primaryDark' : 'secondaryDark'" title="{{ 'CALENDAR.CALENDAR' | translate }}"></fun-new-button>
  </div> -->
  <!-- <div *ngIf="mode === 'calendar'" class="py-[24px]">
    <fun-calendar-pay-timetable [calendarBenefits]="calendarBenefits"></fun-calendar-pay-timetable>
  </div> -->
  <div *ngIf="calendarBenefits && calendarBenefits.length > 0 && mode === 'list'" class="mt-[40px] border border-eggplant-100/[0.1] rounded-3xl px-16 md:px-24">
    <div *ngFor="let benefit of calendarBenefits" >
      <div *ngFor="let movement of benefit.benefits"
      class="py-24 border-b border-b-eggplant-100/[0.1]">
        <!---->
      <div  class="flex justify-between">
        <div class="w-full">
          <div class="flex gap-12 items-center">
            <p *ngIf="!movement.paymentStatus"
            class="font-sans text-s md:text-m text-center uppercase w-fit px-6 rounded-xl pt-2 text-white bg-eggplant-100/[0.25]">Estimado</p>
            <p *ngIf="movement.paymentStatus"
            class="font-sans text-s md:text-m text-center uppercase w-fit px-6 rounded-xl pt-2 text-white"
            [ngClass]="{
                      'bg-active': movement.paymentStatus === 'Programado',
                      'bg-eggplant-70': movement.paymentStatus === 'Aplazado',
                      'bg-cream-100 !text-eggplant-80': movement.paymentStatus === 'Pagado',
                      'bg-orange-100': movement.paymentStatus === 'Cancelado',
                      'bg-eggplant-100/[0.25]': (movement.paymentStatus !== 'Programado' && movement.paymentStatus !== 'Aplazado' && movement.paymentStatus !== 'Cancelado' && movement.paymentStatus !== 'Pagado')
                    }"> {{ movement.paymentStatus }} </p>
            <p *ngIf="!movement.paymentStatus" class="text-l font-sans text-eggplant-80 uppercase">{{ movement.month }}</p>
            <p *ngIf="movement.paymentStatus" class="text-l font-sans text-eggplant-80 uppercase">{{ movement.date[2] }}/{{ movement.date[1] }}/{{ movement.date[0] }}</p>
          </div>
          <p *ngIf="!movement.paymentTitle" class="font-sans text-l md:text-2xl text-eggplant-80 pt-6">{{'PAYMENT_CALENDAR.BENEFITS_COMMON_TYPE' | translate}}</p>
          <p *ngIf="movement.paymentTitle" class="font-sans text-l md:text-2xl text-eggplant-80 pt-6"> {{ movement.paymentTitle }}</p>
        </div>
        <!---->
        <div class="min-w-[80px] md:min-w-[146px] pl-6 py-6 md:py-0 flex items-center justify-center">
          <p *ngIf="movement.amount > 0" class="text-right font-sans text-l md:text-xl text-eggplant-80">{{movement.amount | currency: 'EUR': 'symbol': '1.2-2'}}</p>
          <p *ngIf="movement.amount === 0" class="text-right font-sans text-s md:text-l text-eggplant-100/[0.55]">Por determinar</p>
        </div>
      </div>
        <div *ngIf="movement.paymentDescription">
          <p class="font-sans text-m md:text-l text-eggplant-80 pt-6"> {{ movement.paymentDescription }}</p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="(!calendarBenefits || calendarBenefits.length === 0) && mode === 'list'">
    <fun-overal-message [text]="text" [image]="image" ></fun-overal-message>
  </div>
</div>